var map = {
	"./ke1.jpg": 395,
	"./ke2.jpg": 16,
	"./ke3.jpg": 5161,
	"./ke4.jpg": 1388,
	"./ke5.jpg": 4774,
	"./ke6.jpg": 7439,
	"./ke7.jpg": 651,
	"./ke8.jpg": 8819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2579;